import { createSlice } from '@reduxjs/toolkit';
import { Scheme } from '../../generated/mlmbox/types/scheme';

const initialState: { value: Scheme } = {
    value: {
        assets: [],
        locales: [],
        treeGroups: [],
        trees: [],
        walletAssets: [],
        walletProcessings: [],
        assetPairExchangeRates: [],
    },
};

const schemesSlice = createSlice({
    name: 'schemes',
    initialState,
    reducers: {
        setSchemes: (state, action: { payload: Scheme }) => {
            state.value = action.payload;
        },
    },
});

export const { setSchemes } = schemesSlice.actions;

export default schemesSlice.reducer;
